import React, { useEffect, useState } from 'react';
import SiderComponent from './../components/SiderComponent';
import HeaderComponent from './../components/HeaderComponent';
import axios from 'axios';
import {
  Layout,
  Modal,
  Input,
  Button,
  Table,
  message,
  Space,
  Popconfirm,
} from 'antd';
import greenfeeDealsApi from '../api/greenfeeDeals';

const UserManagement = () => {
  const sessionBnd = localStorage.getItem('sessionBnd');
  const headers = { headers: { Authorization: `Bearer ${sessionBnd}` } };
  const [lang, setLang] = useState('');
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '' });
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [sorter, setSorter] = useState({ field: 'name', order: 'ascend' });
  const [clubSearch, setClubSearch] = useState('');
  const [clubResults, setClubResults] = useState([]);
  const [selectedClub, setSelectedClub] = useState(null);

  useEffect(() => {
    const appLanguage =
      navigator.language || document.documentElement.lang || 'en';

    const isGerman = appLanguage.toLowerCase().startsWith('de');
    setLang(appLanguage);

    fetchUsers();
  }, [pagination.current, pagination.pageSize, sorter, searchText, lang]);

  const fetchUsers = async () => {
    try {
      const res = await greenfeeDealsApi.get('/users/subadmin/all', {
        ...headers,
        params: {
          page: pagination.current,
          limit: pagination.pageSize,
          search: searchText,
          sortField: sorter.field,
          sortOrder: sorter.order,
        },
      });

      setUsers(res.data.data || []);
      setPagination((prev) => ({ ...prev, total: res.data.total }));
    } catch (error) {
      console.error('Error fetching users:', error);
      message.error('Failed to load users');
    }
  };

  const searchClubs = async (text) => {
    setClubSearch(text);

    if (!text) {
      setClubResults([]);
      return;
    }

    try {
      const res = await greenfeeDealsApi.get('/golfclubs/subadmin/search', {
        ...headers,
        params: { name: text },
      });

      setClubResults(res.data.data || []);
    } catch (error) {
      console.error('Club search error:', error);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      let newUser;

      if (editingUser) {
        const res = await greenfeeDealsApi.put(
          `/users/subadmin/${editingUser._id}`,
          form,
          headers,
        );
        newUser = res.data.data; // ✅ FIXED
        message.success('SubAdmin updated successfully!');
      } else {
        const res = await greenfeeDealsApi.post(
          '/users/subadmin',
          form,
          headers,
        );
        newUser = res.data.data;
        message.success('SubAdmin created successfully!');
      }

      if (selectedClub?._id) {
        console.log('Sending adminId:', newUser.id);

        await greenfeeDealsApi.put(
          `/golfclubs/subadmin/${selectedClub._id}/add-admin`,
          { adminId: newUser.id },
          headers,
        );

        message.success('SubAdmin assigned to club!');
      }

      setForm({ firstName: '', lastName: '', email: '' });
      setSelectedClub(null);
      setClubSearch('');
      setEditingUser(null);
      setIsModalOpen(false);
      fetchUsers();
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to save SubAdmin');
    }
  };

  const handleEdit = (record) => {
    const [firstName, lastName] = record.name.split(' ');
    setForm({
      firstName: firstName || '',
      lastName: lastName || '',
      email: record.email || '',
    });
    setEditingUser(record);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      await greenfeeDealsApi.delete(`/users/subadmin/${id}`, headers);
      message.success('SubAdmin deleted successfully!');
      fetchUsers();
    } catch (error) {
      message.error('Failed to delete SubAdmin');
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
    },
    {
      title: 'Zugeordneter Club',
      dataIndex: 'assignedClubs',
      key: 'assignedClubs',
      render: (clubs) => (clubs.length ? clubs.join(', ') : '—'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure delete this SubAdmin?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination(pagination);
    if (sorter.field) {
      setSorter({ field: sorter.field, order: sorter.order });
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <SiderComponent />
      <Layout>
        <HeaderComponent />
        <div
          style={{
            padding: '30px',
            backgroundColor: '#f8f8f8',
            minHeight: '100vh',
          }}
        >
          <h2 style={{ color: '#333', marginBottom: '20px' }}>
            Benutzerverwaltung
          </h2>

          <div
            style={{
              marginBottom: '20px',
              display: 'flex',
              gap: '10px',
              justifyContent: 'space-between',
            }}
          >
            <Input
              placeholder="Suche nach Namen oder Email"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: '250px' }}
            />
            <Button
              type="primary"
              style={{ background: '#00C48C' }}
              onClick={() => {
                setEditingUser(null);
                setForm({ firstName: '', lastName: '', email: '' });
                setIsModalOpen(true);
              }}
            >
              Sub-Admin Anlegen
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={Array.isArray(users) ? users : []}
            rowKey="_id"
            bordered
            pagination={pagination}
            onChange={handleTableChange}
          />

          <Modal
            title={editingUser ? 'Edit SubAdmin' : 'Add SubAdmin'}
            visible={isModalOpen}
            onCancel={() => {
              setIsModalOpen(false);
              setEditingUser(null);
            }}
            footer={[
              <Button key="cancel" onClick={() => setIsModalOpen(false)}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                style={{ background: '#00C48C' }}
                onClick={handleSubmit}
              >
                {editingUser ? 'Update' : 'Submit'}
              </Button>,
            ]}
          >
            <Input
              name="firstName"
              placeholder="First Name"
              value={form.firstName}
              onChange={handleChange}
              style={{ marginBottom: '10px' }}
            />
            <Input
              name="lastName"
              placeholder="Last Name"
              value={form.lastName}
              onChange={handleChange}
              style={{ marginBottom: '10px' }}
            />
            <Input
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              style={{ marginBottom: '10px' }}
              disabled={!!editingUser}
            />
            <Input
              placeholder="Search Club"
              value={clubSearch}
              onChange={(e) => searchClubs(e.target.value)}
              style={{ marginBottom: '10px' }}
            />

            {clubResults.length > 0 && (
              <div
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  maxHeight: '120px',
                  overflowY: 'auto',
                  marginBottom: '10px',
                  padding: '8px',
                }}
              >
                {clubResults.map((club) => (
                  <div
                    key={club._id}
                    onClick={() => {
                      setSelectedClub(club);
                      setClubSearch(club.name);
                      setClubResults([]);
                    }}
                    style={{
                      padding: '5px 10px',
                      cursor: 'pointer',
                      background:
                        selectedClub?._id === club._id ? '#e6fff2' : 'white',
                    }}
                  >
                    {club.name}
                  </div>
                ))}
              </div>
            )}
          </Modal>
        </div>
      </Layout>
    </Layout>
  );
};

export default UserManagement;
